import { useQuery } from '@apollo/client'
import queries from '../../../graphql/queries'
import {
    GetAdminDashboardData,
    GetAdminDashboardDataVariables,
} from '../../../graphql/queries/typings/GetAdminDashboardData'
import { useErrorService } from '../errors/ErrorService'
import { AdminDashboardData } from './models/AdminDashboardData'
import ErrorHelper, { QueryError } from '../errors/ErrorHelper'

type GetAdminDashboardQuery = {
    error?: QueryError
    dashboardData: AdminDashboardData | null
    dashboardDataLoading: boolean
}

export type GetAdminDashboardDataProps = GetAdminDashboardDataVariables

const useGetAdminDashboardData = (props: GetAdminDashboardDataProps): GetAdminDashboardQuery => {
    const { errorAlert } = useErrorService()

    const queryResult = useQuery<GetAdminDashboardData, GetAdminDashboardDataVariables>(queries.GetAdminDashboardData, {
        variables: props,
        fetchPolicy: 'cache-and-network',
    })

    const errorMessage = 'Erreur lors de la récupération des données du dashboard'
    const error = ErrorHelper.getQueryError(queryResult, errorMessage)
    if (queryResult.error) {
        errorAlert(errorMessage, queryResult)
    }

    const queryLoading = queryResult.loading
    const responseData = queryResult.data

    if (!queryLoading) {
        const dashboardData = responseData && responseData.dashboardAea ? responseData.dashboardAea : null

        return {
            error,
            dashboardData,
            dashboardDataLoading: false,
        }
    } else {
        return {
            error,
            dashboardData: null,
            dashboardDataLoading: true,
        }
    }
}

export default useGetAdminDashboardData
